import React, { useState, useRef, useEffect } from "react";
import "./food.css";
import Footer from "../../components/footer/footer";
import FoodRide from "../../components/chooseride/foodride";
import FoodSection from "../../components/section/FoodSection";
import { Link, useNavigate } from "react-router-dom";
import { nitrologo } from "../../utilities/images";
import { useAuth } from "../../AuthContext";
import ProfileNavDropdown from "../../components/navbar/ProfileNavDropdown";
import { useCart } from "../../components/chooseride/CartContext";

function Food() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { clearAllCartData } = useCart();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      // Clear all cart-related data from state and localStorage
      if (clearAllCartData) clearAllCartData();
      // Clear other session/local storage items
      localStorage.removeItem('9troride_address');
      localStorage.removeItem('9troride_locationType');
      sessionStorage.removeItem('9troride_checkoutVendorId');
      sessionStorage.removeItem('9troride_checkoutVendorType');
      navigate('/');
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div>
      <div>
        <nav style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 5%" }}>
          <Link to="/">
            <img src={nitrologo} alt="9troRide Logo" style={{ height: "40px", objectFit: "contain" }} />
          </Link>
          {auth.currentUser ? (
            <div style={{ position: 'relative' }} ref={dropdownRef}>
              <button onClick={() => setIsDropdownOpen(prev => !prev)} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: "8px 16px", backgroundColor: "#f0f0f0", color: "#000", textDecoration: "none", fontWeight: "bold", borderRadius: "100px", border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: '14px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                <span>{auth.riderData?.first_name || auth.currentUser.displayName?.split(' ')[0] || 'Profile'}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
              </button>
              {isDropdownOpen && (
                <ProfileNavDropdown user={auth.currentUser} rider={auth.riderData} onLogout={handleLogout} />
              )}
            </div>
          ) : (
            <Link to="/login" style={{ padding: "10px 24px", backgroundColor: "#E3242B", color: "#fff", textDecoration: "none", fontWeight: "bold", borderRadius: "5px" }}>
              Login
            </Link>
          )}
        </nav>
        <FoodRide />
      </div>
      <FoodSection />
      <Footer />
    </div>
  );
}

export default Food;
